import { resourceList } from './api';
const isResourceId = (resource) => {
    return ((resource === null || resource === void 0 ? void 0 : resource.type) && resource.id) && resourceList.includes(resource.type);
};
const isResourceType = (resource) => {
    return resource && (typeof resource.type !== 'undefined') && resource.type && resourceList.includes(resource.type);
};
export { isResourceId, isResourceType };
/*
// Nullable types
type StringNullable = string | null
type NumberNullable = number | null
type BooleanNullable = boolean | null
type ResourceNullable<R extends Resource> = R | null
type ResourceArrayNullable<R extends Resource> = R[] | null


export type { StringNullable, NumberNullable, BooleanNullable, ResourceNullable, ResourceArrayNullable }
*/
